<script>
/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */
/* eslint-disable no-console */
import {
  urlMethods,
} from "@/state/helpers";
import Swal from "sweetalert2";
export default {
    components: {},
    data: function () {
        return {
            text: "",
            isLoading: false,
            payments : [],
        }
    },
    computed: {
        currentUser: function(){
            return this.$store.getters['auth/currentUser'];
        },
        currentTab: function(){
            return this.$store.getters['sale/currentTab'];
        },
        paymentList: function(){
            let paymentList = this.$store.getters['sale/paymentMethodList'];
            return typeof paymentList != 'undefined' && typeof paymentList[0] != 'undefined' ? paymentList : [];
        },
        totalAmount: function(){
            return typeof this.currentTab != 'undefined' && typeof this.currentTab.info != 'undefined' && typeof this.currentTab.info.totalAmount != 'undefined' ? this.currentTab.info.totalAmount : 0;
        },
        totalEbill: function() {
        return this.$store.getters["sale/totalEbill"];
        },
    },
    methods: {
        ...urlMethods,
        async savePayment(e){
            e.preventDefault();
            try {
                let totalPayment = 0;
                for(var i = 0; i < this.payments.length; i++){
                    totalPayment += this.value;
                }
                if(totalPayment + this.totalEbill < this.totalAmount){
                    throw "Số tiền thanh toán chưa đủ";
                }
                this.$store.dispatch("sale/setTabPayment",this.payments);
                this.$bvModal.hide('modal-payment');
            } catch (error) {
                let text = (typeof error  == 'string' ? error : JSON.stringify(error));
                this.$store.dispatch("sale/setNoti", { 'text' :  text, 'type' : 'error'});
            }
            return false;
        },
        changeValue(index){
            if(this.payments[index].value < 0) this.payments[index].value = 0;
            if(this.payments[index].value >= this.totalAmount - this.totalEbill){
                for(var i = 0; i < this.payments.length; i++){
                    this.payments[i].value = (i != index) ? 0 : this.payments[i].value;
                }
            }
        },
        calcAmount(index){
            let totalPayment = 0;
            for(var i = 0; i < this.payments.length; i++){
                totalPayment += (i != index) ? this.payments[i].value : 0;
            }
            if((this.totalAmount >= totalPayment)){
                this.payments[index].value =  this.totalAmount - totalPayment - this.totalEbill;
            }
        },
        fullAmount(index){
            for(var i = 0; i < this.payments.length; i++){
                this.payments[i].value = (i != index) ? 0 : this.totalAmount - this.totalEbill;
            }
        },
        itemName(item){
            let arr = item.journal_name.split('-');
            return arr.length > 1 ? arr[arr.length - 1].trim() : arr[0].trim();
        }
    },
    mounted() {
        let that = this;
        this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
            if(modalId == 'modal-payment'){
                if(that.currentTab.products.length < 1){
                    that.payments = [];
                }
                if(that.payments.length < 1){
                    for(const item of that.paymentList){
                        let new_item = JSON.parse(JSON.stringify(item));
                        new_item.value = 0;
                        that.payments.push(new_item);
                    }
                }
                setTimeout(() => {
                    this.$refs.payment_value[0].$el.focus();
                },300);
            }
        });
    },
};
</script>

<template>
<b-modal id="modal-payment" title="Khách thanh toán" title-class="font-18" hide-footer>
    <h4 class="text-center mb-3">Tổng tiền: {{ totalAmount | VND }}</h4>
    <form class="form-horizontal" @submit="savePayment" role="form">
        <b-form-group class="mb-3" label-cols-lg="6" label="eBill">
            <money class="form-control text-right" disabled type="text" autocomplete="off" :value="totalEbill"></money>
        </b-form-group>
        <b-form-group v-for="(item,index) in payments" :key="item.statement_id" class="mb-3" label-cols-lg="6" :label="itemName(item)">
            <money class="form-control text-right" @dblclick.native="fullAmount(index)" @click.native="calcAmount(index)" @keyup.native="changeValue(index)" type="text" ref="payment_value" autocomplete="off" v-model="payments[index].value"></money>
        </b-form-group>
        <div class="text-right"><b-button type="submit" variant="primary" ><i class="bx bx-check"></i> Xác nhận</b-button></div>
    </form>
</b-modal>
</template>
